// to replace require_tree
require('js/searches/filter/modals/locked_facet_modal'); // For Boclips
require('./components/modal_facets');
